<!-- 点击已有类似商品弹框按钮 -->
<template>
    <el-dialog append-to-body title="已有类似商品" :visible.sync="centerDialogVisible" width="80%" center>
        <staticTable @upLoading="upLoading" @close="close" :tableData="tableData" :loading="loading" :operationWidth="150"
            :isOperation=false>
        </staticTable>
    </el-dialog>
</template>

<script>
const staticTable = () => import('./staticTable.vue')
export default {
    components: {
        staticTable
    },
    data() {
        return {
            centerDialogVisible: false,
            tableData: [],
            loading: false,
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick(val) {
            this.tableData = val
            this.centerDialogVisible = true
            console.log(this.tableData, '看看渲染的数据');
        },
        close() {
            this.loading = false
            this.centerDialogVisible = false
        },
        upLoading() {
            this.loading = true
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>